import React, { useState } from "react";
import RecusaFornecedor from "../recusa-fornecedor";
import intl from "react-intl-universal";
import "./aceite-volume-fornecedor-sem-parcial.css";
import Button from "components/button";

interface AceiteVolumeFornecedorSemParcialProps {
  idPedido: number;
  accept: (data: any) => void;
  refuse: (idPedido: number) => void;
  disabled: boolean;
  data: any;
  refusalAwareness: boolean;
}

const AceiteVolumeFornecedorSemParcial: React.FC<AceiteVolumeFornecedorSemParcialProps> = ({
  idPedido: orderId,
  accept,
  refuse,
  disabled,
  data,
  refusalAwareness = false
}) => {
  const [showRefuse, setShowRefuse] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);

  const handleAccept = () => {
    setDisableButtons(true);
    accept(data);

    setTimeout(() => {
      setDisableButtons(false);
    }, 2000);
  }

  return (
    <div className="negotiation-line-volume">

      {showRefuse && (
        <RecusaFornecedor
          handleCancel={() => setShowRefuse(false)}
          idPedido={orderId}
          recusa={refuse}
          refusalAwareness={refusalAwareness}
          data-testid="supplier-refuse-button"
        />
      )}

      {!showRefuse && (
        <div className="event-action-volume">
          <Button
            value={intl.get("stocks.timeline.refuse")}
            onClick={() => setShowRefuse(true)}
            buttonType="danger"
            className="button"
            disabled={disabled || disableButtons}
            data-testid="refuse-button"
          />
          <Button
            value={intl.get("stocks.timeline.accept")}
            onClick={handleAccept}
            buttonType="primary"
            className="button"
            disabled={disabled || disableButtons}
            data-testid="accept-button"
          />
        </div>
      )}
    </div>
  );
};

export default AceiteVolumeFornecedorSemParcial;
